module.exports = "<div [style.height.px]=\"height\" class=\"content\" data-cy=\"spinner.component\">\n  <gcv-spinner-icon></gcv-spinner-icon>\n</div>\n"